<template>
  <div class="document-template-page">
    <!-- Page Header with Title -->
    <div class="page-header py-6 px-10">
      <div class="page-title-section">
        <h1 class="page-title">Document Template</h1>
        <p class="page-subtitle">Patient workflows and practice-wide automation currently running</p>
      </div>
      <div class="header-right">
        <div class="view-controls">
          <!-- Original:
          <button 
            class="view-btn" 
            :class="{ active: viewStyle === 'list' }"
            @click="viewStyle = 'list'"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M18 17C18 17.5523 17.5523 18 17 18H1C0.447716 18 0 17.5523 0 17V14.35C0 13.7977 0.447715 13.35 1 13.35H17C17.5523 13.35 18 13.7977 18 14.35V17ZM18 10.35C18 10.9023 17.5523 11.35 17 11.35H1C0.447716 11.35 0 10.9023 0 10.35V7.625C0 7.07271 0.447715 6.625 1 6.625H17C17.5523 6.625 18 7.07272 18 7.625V10.35ZM18 3.625C18 4.17728 17.5523 4.625 17 4.625H1C0.447716 4.625 0 4.17728 0 3.625V1C0 0.447715 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1V3.625Z" fill="currentColor"/>
            </svg>
          </button>
          -->
          <ResponsiveButton
            button_type="text"
            :is_active="viewStyle === 'list'"
            @click-button="viewStyle = 'list'"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M18 17C18 17.5523 17.5523 18 17 18H1C0.447716 18 0 17.5523 0 17V14.35C0 13.7977 0.447715 13.35 1 13.35H17C17.5523 13.35 18 13.7977 18 14.35V17ZM18 10.35C18 10.9023 17.5523 11.35 17 11.35H1C0.447716 11.35 0 10.9023 0 10.35V7.625C0 7.07271 0.447715 6.625 1 6.625H17C17.5523 6.625 18 7.07272 18 7.625V10.35ZM18 3.625C18 4.17728 17.5523 4.625 17 4.625H1C0.447716 4.625 0 4.17728 0 3.625V1C0 0.447715 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1V3.625Z" fill="currentColor"/>
              </svg>
            </template>
          </ResponsiveButton>
          <!-- Original:
          <button 
            class="view-btn" 
            :class="{ active: viewStyle === 'grid' }"
            @click="viewStyle = 'grid'"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M11 18C10.4477 18 10 17.5523 10 17V11C10 10.4477 10.4477 10 11 10H17C17.5523 10 18 10.4477 18 11V17C18 17.5523 17.5523 18 17 18H11ZM11 8C10.4477 8 10 7.55228 10 7V1C10 0.447715 10.4477 0 11 0H17C17.5523 0 18 0.447715 18 1V7C18 7.55228 17.5523 8 17 8H11ZM1 8C0.447715 8 0 7.55228 0 7V1C0 0.447715 0.447715 0 1 0H7C7.55228 0 8 0.447715 8 1V7C8 7.55228 7.55228 8 7 8H1ZM1 18C0.447715 18 0 17.5523 0 17V11C0 10.4477 0.447715 10 1 10H7C7.55228 10 8 10.4477 8 11V17C8 17.5523 7.55228 18 7 18H1Z" fill="currentColor"/>
            </svg>
          </button>
          -->
          <ResponsiveButton
            button_type="text"
            :is_active="viewStyle === 'grid'"
            @click-button="viewStyle = 'grid'"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M11 18C10.4477 18 10 17.5523 10 17V11C10 10.4477 10.4477 10 11 10H17C17.5523 10 18 10.4477 18 11V17C18 17.5523 17.5523 18 17 18H11ZM11 8C10.4477 8 10 7.55228 10 7V1C10 0.447715 10.4477 0 11 0H17C17.5523 0 18 0.447715 18 1V7C18 7.55228 17.5523 8 17 8H11ZM1 8C0.447715 8 0 7.55228 0 7V1C0 0.447715 0.447715 0 1 0H7C7.55228 0 8 0.447715 8 1V7C8 7.55228 7.55228 8 7 8H1ZM1 18C0.447715 18 0 17.5523 0 17V11C0 10.4477 0.447715 10 1 10H7C7.55228 10 8 10.4477 8 11V17C8 17.5523 7.55228 18 7 18H1Z" fill="currentColor"/>
              </svg>
            </template>
          </ResponsiveButton>
          <!-- Original:
          <button 
            class="view-btn" 
            :class="{ active: viewStyle === 'grid-large', disabled: !isGridLargeAvailable }"
            :disabled="!isGridLargeAvailable"
            @click="isGridLargeAvailable && (viewStyle = 'grid-large')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M1 20C0.447715 20 0 19.5523 0 19V15C0 14.4477 0.447715 14 1 14H5C5.55228 14 6 14.4477 6 15V19C6 19.5523 5.55228 20 5 20H1ZM8 20C7.44772 20 7 19.5523 7 19V15C7 14.4477 7.44772 14 8 14H12C12.5523 14 13 14.4477 13 15V19C13 19.5523 12.5523 20 12 20H8ZM15 20C14.4477 20 14 19.5523 14 19V15C14 14.4477 14.4477 14 15 14H19C19.5523 14 20 14.4477 20 15V19C20 19.5523 19.5523 20 19 20H15ZM1 13C0.447715 13 0 12.5523 0 12V8C0 7.44772 0.447715 7 1 7H5C5.55228 7 6 7.44772 6 8V12C6 12.5523 5.55228 13 5 13H1ZM8 13C7.44772 13 7 12.5523 7 12V8C7 7.44772 7.44772 7 8 7H12C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13H8ZM15 13C14.4477 13 14 12.5523 14 12V8C14 7.44772 14.4477 7 15 7H19C19.5523 7 20 7.44772 20 8V12C20 12.5523 19.5523 13 19 13H15ZM1 6C0.447715 6 0 5.55228 0 5V1C0 0.447715 0.447715 0 1 0H5C5.55228 0 6 0.447715 6 1V5C6 5.55228 5.55228 6 5 6H1ZM8 6C7.44772 6 7 5.55228 7 5V1C7 0.447715 7.44772 0 8 0H12C12.5523 0 13 0.447715 13 1V5C13 5.55228 12.5523 6 12 6H8ZM15 6C14.4477 6 14 5.55228 14 5V1C14 0.447715 14.4477 0 15 0H19C19.5523 0 20 0.447715 20 1V5C20 5.55228 19.5523 6 19 6H15Z" fill="currentColor"/>
            </svg>
          </button>
          -->
          <ResponsiveButton
            button_type="text"
            :is_active="viewStyle === 'grid-large'"
            :disabled="!isGridLargeAvailable"
            @click-button="isGridLargeAvailable && (viewStyle = 'grid-large')"
          >
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M1 20C0.447715 20 0 19.5523 0 19V15C0 14.4477 0.447715 14 1 14H5C5.55228 14 6 14.4477 6 15V19C6 19.5523 5.55228 20 5 20H1ZM8 20C7.44772 20 7 19.5523 7 19V15C7 14.4477 7.44772 14 8 14H12C12.5523 14 13 14.4477 13 15V19C13 19.5523 12.5523 20 12 20H8ZM15 20C14.4477 20 14 19.5523 14 19V15C14 14.4477 14.4477 14 15 14H19C19.5523 14 20 14.4477 20 15V19C20 19.5523 19.5523 20 19 20H15ZM1 13C0.447715 13 0 12.5523 0 12V8C0 7.44772 0.447715 7 1 7H5C5.55228 7 6 7.44772 6 8V12C6 12.5523 5.55228 13 5 13H1ZM8 13C7.44772 13 7 12.5523 7 12V8C7 7.44772 7.44772 7 8 7H12C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13H8ZM15 13C14.4477 13 14 12.5523 14 12V8C14 7.44772 14.4477 7 15 7H19C19.5523 7 20 7.44772 20 8V12C20 12.5523 19.5523 13 19 13H15ZM1 6C0.447715 6 0 5.55228 0 5V1C0 0.447715 0.447715 0 1 0H5C5.55228 0 6 0.447715 6 1V5C6 5.55228 5.55228 6 5 6H1ZM8 6C7.44772 6 7 5.55228 7 5V1C7 0.447715 7.44772 0 8 0H12C12.5523 0 13 0.447715 13 1V5C13 5.55228 12.5523 6 12 6H8ZM15 6C14.4477 6 14 5.55228 14 5V1C14 0.447715 14.4477 0 15 0H19C19.5523 0 20 0.447715 20 1V5C20 5.55228 19.5523 6 19 6H15Z" fill="currentColor"/>
              </svg>
            </template>
          </ResponsiveButton>
        </div>
      </div>
    </div>

    <!-- Global Search Bar -->
    <div class="px-10 pb-4">
      <div class="search-container">
        <div class="search-label">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="#374957"/>
          </svg>
          <span class="search-label-text">Search Through Template</span>
        </div>
        <!-- Original:
        <div class="search-input-wrapper">
          <input
            :value="localSearchQuery"
            @input="handleSearchQueryChange($event.target.value)"
            type="text"
            class="search-input"
            placeholder="Search item across tabs..."
          />
          <button
            v-if="localSearchQuery"
            class="clear-btn"
            @click="handleSearchQueryChange('')"
          >
            Clear
          </button>
        </div>
        -->
        <TextInput
          v-model="localSearchQuery"
          placeholder="Search item across tabs..."
          :clearable="true"
        />
      </div>
    </div>

    <!-- Tab Navigation -->
    <!-- Original:
    <div class="px-10 mb-[2px]">
      <div class="tab-navigation">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'smart-block' }"
          @click="activeTab = 'smart-block'"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M13.3333 4.31243L15.6917 6.67077L13.3333 9.0291L10.975 6.67077L13.3333 4.31243ZM6.95001 4.71243V8.04577H3.61668V4.71243H6.95001ZM15.2833 13.0458V16.3791H11.95V13.0458H15.2833ZM6.95001 13.0458V16.3791H3.61668V13.0458H6.95001ZM13.3333 1.9541L8.61668 6.66244L13.3333 11.3791L18.05 6.66244L13.3333 1.9541ZM8.61668 3.04577H1.95001V9.71243H8.61668V3.04577ZM16.95 11.3791H10.2833V18.0458H16.95V11.3791ZM8.61668 11.3791H1.95001V18.0458H8.61668V11.3791Z" fill="#374957"/>
          </svg>
          <span>Smart Block</span>
        </div>
        <div
          class="tab-item"
          :class="{ active: activeTab === 'my-documents' }"
          @click="activeTab = 'my-documents'"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M13.75 0.833496H3.75001C2.83334 0.833496 2.08334 1.5835 2.08334 2.50016V14.1668H3.75001V2.50016H13.75V0.833496ZM12.9167 4.16683H7.08334C6.16668 4.16683 5.42501 4.91683 5.42501 5.8335L5.41668 17.5002C5.41668 18.4168 6.15834 19.1668 7.07501 19.1668H16.25C17.1667 19.1668 17.9167 18.4168 17.9167 17.5002V9.16683L12.9167 4.16683ZM7.08334 17.5002V5.8335H12.0833V10.0002H16.25V17.5002H7.08334Z" fill="#374957"/>
          </svg>
          <span>My Documents</span>
        </div>
      </div>
    </div>
    -->
    <Tab
      v-model="activeTab"
      type="outlined"
      :tabs="tabItems"
    >
      <template #icon-0>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M13.75 0.833496H3.75001C2.83334 0.833496 2.08334 1.5835 2.08334 2.50016V14.1668H3.75001V2.50016H13.75V0.833496ZM12.9167 4.16683H7.08334C6.16668 4.16683 5.42501 4.91683 5.42501 5.8335L5.41668 17.5002C5.41668 18.4168 6.15834 19.1668 7.07501 19.1668H16.25C17.1667 19.1668 17.9167 18.4168 17.9167 17.5002V9.16683L12.9167 4.16683ZM7.08334 17.5002V5.8335H12.0833V10.0002H16.25V17.5002H7.08334Z" fill="currentColor"/>
        </svg>
      </template>
    </Tab>

    <!-- Content Area with White Background -->
    <div class="content-area -mr-5 -ml-5 px-10">
      <div class="documents-content">
        <!-- Filter Row -->
        <div class="filter-row">
          <!-- Original:
          <div class="filter-item">
            <label class="filter-label">Filter by Type</label>
            <SingleSelector
              :modelValue="filterType"
              @update:modelValue="handleFilterTypeChange"
              placeholder="All"
              :options="typeOptions"
              :hasLabel="false"
            />
          </div>
          -->
          <div class="filter-item">
              <Label label="Filter by Type">
                <SingleSelector
                  size="medium"
                  v-model="filterTypeModel"
                  placeholder="All"
                  :options="typeOptions"
                />
              </Label>
          </div>
          
          <!-- Original:
          <div class="filter-item">
            <label class="filter-label">Filter by Time</label>
            <SingleSelector
              :modelValue="filterTime"
              @update:modelValue="handleFilterTimeChange"
              placeholder="All time"
              :options="timeOptions"
              :hasLabel="false"
            />
          </div>
          -->
          <div class="filter-item">
              <Label label="Filter by Time">
                <SingleSelector
                  size="medium"
                  v-model="filterTimeModel"
                  placeholder="All time"
                  :options="timeOptions"
                />
              </Label>
          </div>
          <div class="filter-actions">
            <!-- Original:
            <Button colorType="sky-blue" @click="handleBrowseTemplates">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20.77C21.45 20 22 19.44 22 18.77V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM18 12H6V10H18V12ZM14 16H6V14H14V16Z" fill="white"/>
              </svg>
              <span style="margin-left: 4px;">Browse Templates</span>
            </Button>
            -->
            <ResponsiveButton
              display_name="Browse Templates"
              button_type="filled"
              built_in_theme="light"
              size="medium"
              @click-button="handleBrowseTemplates"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20.77C21.45 20 22 19.44 22 18.77V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM18 12H6V10H18V12ZM14 16H6V14H14V16Z" fill="white"/>
                </svg>
              </template>
            </ResponsiveButton>
            <!-- Original:
            <Button colorType="dark-blue" @click="handleCreateDocument">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M13 11H11V14H8V16H11V19H13V16H16V14H13V11ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" fill="white"/>
              </svg>
              <span style="margin-left: 4px;">Create Document</span>
            </Button>
            -->
            <ResponsiveButton
              display_name="Create Document"
              button_type="filled"
              built_in_theme="dark"
              size="medium"
              @click-button="handleCreateDocument"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M13 11H11V14H8V16H11V19H13V16H16V14H13V11ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" fill="white"/>
                </svg>
              </template>
            </ResponsiveButton>
          </div>
        </div>

        <div class="documents-scroll-area">
          <!-- Loading State -->
          <div v-if="isLoadingForms" class="loading-state">
            Loading forms...
          </div>
          
          <!-- Error State -->
          <div v-else-if="homePageError" class="error-state">
            {{ homePageError }}
          </div>
          
          <!-- Documents Grid -->
          <div v-else class="documents-grid" :class="`grid-${viewStyle}`">
            <WorkbenchCard
              v-for="doc in paginatedDocuments"
              :key="doc.id"
              :title="doc.name || doc.title"
              :description="doc.description"
              :notes="`Updated ${moment(doc.updated_at || doc.updatedAt).format('MM/DD/YYYY HH:mm')}`"
              :showPreview="true"
              :showEdit="true"
              :showArchive="true"
              @preview="handlePreviewDocument(doc)"
              @edit="handleEditDocument(doc)"
              @archive="handleArchiveDocument(doc)"
            >
              <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" viewBox="0 0 19 24" fill="none">
                  <path d="M4.75 13.2H14.25V10.8H4.75V13.2ZM4.75 16.8H14.25V14.4H4.75V16.8ZM4.75 20.4H10.6875V18H4.75V20.4ZM2.375 24C1.72187 24 1.16276 23.765 0.697656 23.295C0.232552 22.825 0 22.26 0 21.6V2.4C0 1.74 0.232552 1.175 0.697656 0.705C1.16276 0.235 1.72187 0 2.375 0H11.875L19 7.2V21.6C19 22.26 18.7674 22.825 18.3023 23.295C17.8372 23.765 17.2781 24 16.625 24H2.375ZM10.6875 8.4V2.4H2.375V21.6H16.625V8.4H10.6875Z" fill="currentColor"/>
                </svg>
              </template>
            </WorkbenchCard>
            
            <!-- Create New Card -->
            <CreateNewCard text-content="Create New Document" @click="handleCreateDocument" />
          </div>
        </div>

        <div class="pagination-footer">
          <!-- Original:
          <MedicationPagination
            :total="totalCount"
            :page-size="pageSize"
            :current-page="currentPage"
            :page-size-options="pageSizeOptions"
            @page-change="handlePageChange"
            @page-size-change="handlePageSizeChange"
          />
          -->
          <Pagination
            :show_summary="false"
            :total_items="totalCount"
            :current_page="currentPage"
            :per_page="pageSize"
            :per_page_options="pageSizeOptions"
            @update:current_page="handlePageChange"
            @update:per_page="handlePageSizeChange"
          />
        </div>
      </div>
    </div>

    <!-- Form Preview Modal -->
    <FormPreviewModal
      :visible="isPreviewModalVisible"
      :formElements="previewFormElements"
      :formTitle="previewFormTitle"
      :loading="isLoadingPreview"
      @close="handleClosePreview"
      @submit="handlePreviewSubmit"
      :hasCancelButton="false"
      :hasSubmitButton="false"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import WorkbenchCard from '@/views/commonComponents/WorkbenchCard.vue';
import CreateNewCard from '@/views/commonComponents/CreateNewCard.vue';
// import SingleSelector from '@/NewLibrary/SingleSelector.vue';
// import Button from '@/NewLibrary/Button.vue';
// import MedicationPagination from '@/NewLibrary/MedicationPagination.vue';
import FormPreviewModal from '../create-document/components/FormPreviewModal.vue';
import { notify } from '@/utils/notify';
import moment from 'moment';
import debounce from 'lodash/debounce';

/**
 * Document Template Home Page
 * 
 * Displays list of forms with filtering, searching, and pagination.
 * Uses Vuex store for business state, keeps only UI preferences local.
 * 
 * State Management:
 * - Business state (forms, filters, pagination) → Vuex store
 * - UI state (view style, window width, active tab) → Local component state
 */
export default {
  name: 'DocumentTemplate',
  components: {
    WorkbenchCard,
    CreateNewCard,
    // SingleSelector, // replaced by globally registered SingleSelector
    // Button, // replaced by globally registered ResponsiveButton
    // MedicationPagination, // replaced by globally registered Pagination
    FormPreviewModal
  },
  
  data() {
    return {
      // ═══════════════════════════════════════════════════════════
      // UI STATE (Local) - View preferences and UI interactions
      // ═══════════════════════════════════════════════════════════
      
      /** Active tab selection: 'smart-block' | 'my-documents' */
      activeTab: 'my-documents',

      /** Tab items for library Tab component */
      tabItems: [
        { value: 'my-documents', label: 'My Documents', icon: true },
        // { value: 'smart-block', label: 'Smart Block' }, // Hide temporarily. Save for future development
      ],
      
      /** View style: 'list' | 'grid' | 'grid-large' */
      viewStyle: 'grid',
      
      /** Window width for responsive behavior */
      windowWidth: window.innerWidth,
      
      /** Flag for preview modal visibility */
      isPreviewModalVisible: false,
      
      /** Loading state for preview modal */
      isLoadingPreview: false,
      
      /** Form elements for preview */
      previewFormElements: [],
      
      /** Form title for preview */
      previewFormTitle: '',
      
      /** Local search query for immediate UI feedback */
      localSearchQuery: '',
      
      // ═══════════════════════════════════════════════════════════
      // FILTER OPTIONS (Static) - Available options for dropdowns
      // ═══════════════════════════════════════════════════════════
      
      typeOptions: [
        { value: 'all', label: 'All' },
        { value: 'intake', label: 'Intake Form' },
        { value: 'consent', label: 'Consent Form' },
        { value: 'history', label: 'Medical History' }
      ],
      
      timeOptions: [
        { value: 'all', label: 'All time' },
        { value: 'today', label: 'Today' },
        { value: 'week', label: 'Last 7 days' },
        { value: 'month', label: 'Last 30 days' },
        { value: 'quarter', label: 'Last 90 days' }
      ],
      
      pageSizeOptions: [5, 10, 20],
    };
  },
  computed: {
    // ─────────────────────────────────────────────────────────
    // Map Vuex Store State
    // ─────────────────────────────────────────────────────────
    ...mapState('workbench/formBuilder', {
      paginatedDocuments: 'homePageForms',
      searchQuery: state => state.homePageFilters.searchQuery,
      filterType: state => state.homePageFilters.filterType,
      filterTime: state => state.homePageFilters.filterTime,
      currentPage: state => state.homePagePagination.currentPage,
      pageSize: state => state.homePagePagination.pageSize,
      isLoadingForms: 'isLoadingForms',
      homePageError: 'homePageError',
    }),
    
    // ─────────────────────────────────────────────────────────
    // Map Vuex Store Getters
    // ─────────────────────────────────────────────────────────
    ...mapGetters('workbench/formBuilder', {
      totalCount: 'homePageTotalCount',
    }),
    
    // ─────────────────────────────────────────────────────────
    // Local Computed Properties
    // ─────────────────────────────────────────────────────────
    
    /**
     * Check if grid-large view is available based on window width
     */
    isGridLargeAvailable() {
      return this.windowWidth >= 1400;
    },

    /**
     * Merged snapshot of query INPUTS only (filters + currentPage + pageSize).
     * Deliberately excludes totalCount so that SET_TOTAL_COUNT commits inside
     * initHomePage do not re-trigger the watcher and cause a second API call.
     */
    storeQueryState() {
      const { searchQuery, filterType, filterTime, customStartDate, customEndDate, status } =
        this.$store.state.workbench.formBuilder.homePageFilters;
      const { currentPage, pageSize } =
        this.$store.state.workbench.formBuilder.homePagePagination;
      return { searchQuery, filterType, filterTime, customStartDate, customEndDate, status, currentPage, pageSize };
    },

    /**
     * Writable computed for filterType — enables v-model on SingleSelector
     */
    filterTypeModel: {
      get() { return this.filterType; },
      set(val) { this.updateFilterType(val); }
    },

    /**
     * Writable computed for filterTime — enables v-model on SingleSelector
     */
    filterTimeModel: {
      get() { return this.filterTime; },
      set(val) { this.updateFilterTime(val); }
    },
  },
  watch: {
    /**
     * Fires whenever query inputs (filters or pagination) change.
     * totalCount is intentionally excluded from storeQueryState so that
     * SET_TOTAL_COUNT commits inside initHomePage do not re-trigger this
     * watcher and cause a second API call.
     * Vue 3 batches synchronous commits within one action into a single
     * flush, so this handler fires exactly once per action call.
     */
    storeQueryState: {
      handler() {
        this.$store.dispatch('workbench/formBuilder/initHomePage');
      },
      deep: true
    },

    /**
     * Debounce-forward local search query changes to the store.
     * Runs for both typing and clear-button events via v-model.
     */
    localSearchQuery(newVal) {
      this.debouncedUpdateSearch(newVal);
    },
  },
  
  created() {
    // Create debounced search handler (500ms delay)
    this.debouncedUpdateSearch = debounce((query) => {
      this.updateSearchQuery(query);
    }, 500);
  },
  
  async mounted() {
    // Initialize local search query from store
    this.localSearchQuery = this.searchQuery;
    
    // Initialize page: load forms from store/API
    await this.initHomePage();
    
    // Setup window resize listener for responsive view
    window.addEventListener('resize', this.handleResize);
  },
  
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    // Cancel any pending debounced calls
    if (this.debouncedUpdateSearch) {
      this.debouncedUpdateSearch.cancel();
    }
  },
  methods: {
    // ─────────────────────────────────────────────────────────
    // Map Vuex Store Actions
    // ─────────────────────────────────────────────────────────
    ...mapActions('workbench/formBuilder', [
      'initHomePage',
      'updateSearchQuery',
      'updateFilterType',
      'updateFilterTime',
      'changePage',
      'changePageSize',
    ]),
    
    // ─────────────────────────────────────────────────────────
    // Helper Methods
    // ─────────────────────────────────────────────────────────
    
    /**
     * Expose moment to template
     */
    moment,
    
    // ─────────────────────────────────────────────────────────
    // UI Event Handlers
    // ─────────────────────────────────────────────────────────
    
    /**
     * Handle window resize for responsive view switching
     */
    handleResize() {
      this.windowWidth = window.innerWidth;
      
      // Auto-switch from grid-large to grid if window too small
      if (!this.isGridLargeAvailable && this.viewStyle === 'grid-large') {
        this.viewStyle = 'grid';
      }
    },
    
    /**
     * Handle pagination page change
     */
    handlePageChange(page) {
      this.changePage(page);
    },
    
    /**
     * Handle pagination page size change
     */
    handlePageSizeChange(size) {
      this.changePageSize(size);
    },
    
    // ─────────────────────────────────────────────────────────
    // Navigation Handlers
    // ─────────────────────────────────────────────────────────
    
    /**
     * Navigate to template marketplace
     */
    handleBrowseTemplates() {
      this.$router.push('/my-workbench/template-marketplace');
    },
    
    /**
     * Navigate to create new document
     */
    handleCreateDocument() {
      this.$router.push('/my-workbench/document-template/create-document');
    },
    
    // ─────────────────────────────────────────────────────────
    // Document Action Handlers (TODO: Implement)
    // ─────────────────────────────────────────────────────────
    
    /**
     * Preview document form
     * Loads form details (with definition.fields) using cache-first strategy
     */
    async handlePreviewDocument(doc) {
      try {
        // Show loading state
        this.isLoadingPreview = true;
        this.isPreviewModalVisible = true;
        
        // Load form details (uses cache if available)
        const formDetails = await this.$store.dispatch('workbench/formBuilder/loadFormDetails', { 
          formId: doc.id 
        });
        
        // Extract form elements from definition.fields
        this.previewFormElements = formDetails.definition?.fields || [];
        this.previewFormTitle = formDetails.name;
      } catch (error) {
        console.error('Error loading form preview:', error);
        notify({
          title: 'Error',
          type: 'error',
          message: 'Failed to load form preview',
          duration: 3000
        });
        this.isPreviewModalVisible = false;
      } finally {
        this.isLoadingPreview = false;
      }
    },
    
    /**
     * Close preview modal
     */
    handleClosePreview() {
      this.isPreviewModalVisible = false;
      this.previewFormElements = [];
    },
    
    /**
     * Handle form submission from preview modal
     */
    handlePreviewSubmit(formData) {
      console.log('Form preview submitted with data:', formData);
      this.isPreviewModalVisible = false;
      this.previewFormElements = [];
      notify({
        title: 'Success',
        type: 'success',
        message: 'Form preview submitted successfully!',
        duration: 3000
      });
    },
    
    /**
     * Edit existing document
     * Pre-loads form details before navigation for better UX
     */
    async handleEditDocument(doc) {
      try {
        // Pre-load form details to cache (speeds up editor loading)
        await this.$store.dispatch('workbench/formBuilder/loadFormDetails', { 
          formId: doc.id 
        });
        
        // Navigate to create-document page with document ID
        // The create-document page will use cached data via initFormEditor
        this.$router.push(`/my-workbench/document-template/create-document/${doc.id}`);
      } catch (error) {
        console.error('Error loading form for editing:', error);
        // Still navigate even if pre-loading fails - initFormEditor will handle the error
        this.$router.push(`/my-workbench/document-template/create-document/${doc.id}`);
      }
    },
    
    /**
     * Archive document (with confirmation)
     */
    async handleArchiveDocument(doc) {
      // Show confirmation dialog
      const confirmed = await this.$confirm(
        `Are you sure you want to archive "${doc.name}"? You can restore it later from archived forms.`,
        'Archive Form',
        {
          confirmButtonText: 'Archive',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).catch(() => false);
      
      if (!confirmed) {
        return;
      }
      
      try {
        // Call archive action
        const result = await this.$store.dispatch('workbench/formBuilder/archiveForm', doc.id);
        
        if (result.success) {
          notify({
            title: 'Success',
            type: 'success',
            message: `Form "${doc.name}" has been archived successfully`,
            duration: 3000
          });
        } else {
          notify({
            title: 'Error',
            type: 'error',
            message: result.error?.message || 'Failed to archive form',
            duration: 3000
          });
        }
      } catch (error) {
        console.error('Error archiving form:', error);
        notify({
          title: 'Error',
          type: 'error',
          message: 'Failed to archive form',
          duration: 3000
        });
      }
    }
  }
}
</script>

<style scoped>
.document-template-page {
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.page-title-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-title {
  font-family: 'Avenir', sans-serif;
  font-size: 22px;
  font-weight: 500;
  line-height: 24px;
  color: #333;
  margin: 0;
  white-space: nowrap;
}

.page-subtitle {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #666;
  margin: 0;
}

.header-right {
  flex-shrink: 0;
}

.view-controls {
  display: flex;
  gap: 16px;
}

:deep(.view-btn) {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999999;
  background: transparent;
  transition: all 0.2s ease;
  box-sizing: border-box;
  border-radius: 2px;
}

:deep(.view-btn:hover:not(.disabled)) {
  background: rgba(0, 72, 121, 0.08);
  color: rgba(0, 72, 121, 1);
}

:deep(.view-btn.active) {
  color: #374957;
}

:deep(.view-btn.disabled) {
  cursor: not-allowed;
  opacity: 0.4;
  background: #F9F9F9;
}

:deep(.view-btn.disabled:hover) {
  border-color: #E5E7EB;
}

/* Search Container */
.search-container {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  max-width: 1100px;
}

.search-label {
  display: flex;
  gap: 4px;
  align-items: center;
  flex-shrink: 0;
}

.search-label-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4A4A4A;
}

.search-input-wrapper {
  position: relative;
  flex: 1;
  min-width: 0;
}

.search-input {
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #111827;
  transition: all 0.2s ease;
}

.search-input:focus {
  outline: none;
  border-color: #004879;
}

.search-input::placeholder {
  color: #999;
}

:deep(.clear-btn) {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #1E4670;
  text-decoration: underline;
  cursor: pointer;
  padding: 4px 10px;
  transition: opacity 0.2s ease;
}

:deep(.clear-btn:hover) {
  opacity: 0.7;
}

/* Tab Navigation */
.tab-navigation {
  display: flex;
  gap: 8px;
  padding: 0;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #666;
  background-color: #fff;
  cursor: pointer;
  padding: 10px 12px;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
  position: relative;
  bottom: -1px;
  box-shadow: 0 -4px 6px rgba(164,164,164,0.25),
              4px 0 6px rgba(164,164,164,0.25),
              -4px 0 6px rgba(164,164,164,0.25);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.tab-item:hover {
  color: #004879;
}

.tab-item.active {
  color: #004879;
  border-bottom-color: #004879;
  box-shadow: -1px -1px 15px 0px rgba(164, 164, 164, 0.25), 1px -1px 15px 0px rgba(164, 164, 164, 0.25);
  border-left: 1px solid #004879;
  border-right: 1px solid #004879;
  border-top: 1px solid #004879;
}

/* Content Area */
.content-area {
  background: #FFFFFF;
  margin: 0;
  box-shadow: 0px 1px 15px 0px rgba(164, 164, 164, 0.25);
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.documents-content {
  padding: 20px 0 0;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.documents-scroll-area {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.pagination-footer {
  flex-shrink: 0;
  background: #FFFFFF;
  padding: 0 0 16px;
}
/* SingleSelector styles - same as ez-bill */
.document-template-page :deep(.new-libary-single-selector .el-select__wrapper){
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
  height: 40px !important;
  min-height: 40px !important;
}

.document-template-page :deep(.new-libary-single-selector .el-select__wrapper:hover),
.document-template-page :deep(.new-libary-single-selector .el-select__wrapper.is-focus) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
  height: 40px !important;
}

/* Filter Row */
.filter-row {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  max-width: 314px;
}

.filter-label {
  overflow: hidden;
  color: var(--color-Grey-Grey-4A, #4A4A4A);
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.filter-item :deep(.new-libary-single-selector) {
  width: 314px;
}

.filter-actions {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

/* Loading and Error States */
.loading-state,
.error-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  color: #666;
}

.error-state {
  color: #d32f2f;
}

/* Documents Grid */
.documents-grid {
  display: grid;
  gap: 16px;
  margin-bottom: 24px;
}

.documents-grid.grid-list {
  grid-template-columns: 1fr;
}

.documents-grid.grid-grid {
  grid-template-columns: repeat(2, 1fr);
}

.documents-grid.grid-grid-large {
  grid-template-columns: repeat(3, 1fr);
}

/* Pagination Section */

/* Responsive Design */
@media (max-width: 1200px) {
  .documents-grid.grid-grid-large {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .filter-row {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filter-actions {
    margin-left: 0;
    margin-top: 8px;
  }
}

@media (max-width: 768px) {
  .documents-grid.grid-grid,
  .documents-grid.grid-grid-large {
    grid-template-columns: 1fr;
  }
  
  .tab-navigation {
    flex-wrap: wrap;
  }
}

@media (max-width: 576px) {
  .page-title {
    font-size: 18px;
  }
  
  .page-subtitle {
    font-size: 14px;
  }
  
  .filter-item :deep(.new-libary-single-selector) {
    width: 100%;
  }
}
</style>